import { Box, UnstyledButton } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { Check, Copy } from 'lucide-react';
import type { FC } from 'react';
import { cn } from '@/utils';

type TScriptClipboardProps = {
	scriptValue: string;
	isMiniCreatorMode: boolean;
};

const ScriptClipboard: FC<TScriptClipboardProps> = ({
	isMiniCreatorMode,
	scriptValue = `<script>
  let newoBot = {
    botId: "abc123xyz",
    position: "bottom-right",
    primaryColor: "#f97316",
    greeting: "Hi! How can I help you today?"
  };
</script>`
}) => {
	const clipboard = useClipboard();

	const handleCopy = () => clipboard.copy(scriptValue);

	return (
		<Box
			className={cn(
				'flex items-start relative w-full p-[18px] gap-[12px]',
				'self-stretch border border-[#DEE2E6] rounded-[4px]',
				{
					'sm:w-[480px]': !isMiniCreatorMode
				}
			)}
		>
			<p
				className="!p-0 !m-0 w-full overflow-hidden text-black text-start text-ellipsis
			[font-family:var(--font-body)] text-[12.5px] font-medium leading-[24.5px]
			tracking-[-0.25px] opacity-50"
			>
				{scriptValue}
			</p>
			<UnstyledButton
				className="absolute top-3 right-1 bg-transparent hover:bg-transparent
                   rounded-[6px] px-[8px] py-[4px]
                   flex items-center gap-[4px] transition"
				onClick={handleCopy}
			>
				{clipboard.copied ? (
					<Check className="w-4 h-4 text-primary-900" />
				) : (
					<Copy className="w-4 h-4 text-primary-900" />
				)}
			</UnstyledButton>
		</Box>
	);
};

export default ScriptClipboard;
